import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title = "", subtitle = "" }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="24px">
      <Typography
        variant="h3"
        color={colors.grey[100]}
        fontWeight={700}
        sx={{ m: "0 0 4px 0" }}
      >
        {title}
      </Typography>
      <Typography variant="h6" color={colors.redAccent[500]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;